var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9509 17.4884C12.1109 17.6484 12.3309 17.7384 12.5409 17.7384C12.7509 17.7384 12.9709 17.6584 13.1309 17.4884L18.4809 12.1384C18.8109 11.8084 18.8109 11.2784 18.4809 10.9484C18.1509 10.6184 17.6209 10.6184 17.2909 10.9484L13.3409 14.8984V3.23844C13.3409 2.77844 12.9609 2.39844 12.5009 2.39844C12.0409 2.39844 11.6609 2.77844 11.6609 3.23844V14.8184L7.71094 10.8684C7.38094 10.5384 6.85094 10.5384 6.52094 10.8684C6.19094 11.1984 6.19094 11.7284 6.52094 12.0584L11.9509 17.4884Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.2584 19.9219H3.73844C3.27844 19.9219 2.89844 20.3019 2.89844 20.7619C2.89844 21.2219 3.27844 21.6019 3.73844 21.6019H21.2584C21.7184 21.6019 22.0984 21.2219 22.0984 20.7619C22.0984 20.3019 21.7184 19.9219 21.2584 19.9219Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIcon);
export default __webpack_public_path__ + "static/media/down_icon.2be3b0477d265388bbe1e0a862413cbc.svg";
export { ForwardRef as ReactComponent };